import { apiSlice } from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => ({
        url: "/tasks",
        method: "GET",
      }),
    }),
    getTask: builder.query({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "GET",
      }),
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const task = await queryFulfilled;
          if (task?.data?.id) {
            // update cache pessimistically start
            dispatch(
              apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
                draft.push(task.data);
              })
            );
            // update cache pessimistically end
          }
        } catch (error) {}
      },
    }),
    editTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const task = await queryFulfilled;
          if (task?.data?.id) {
            // update homepage cache pessimistically start
            dispatch(
              apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
                const editedDraft = draft.find((t) => t.id === task.data.id);
                Object.assign(editedDraft, task.data);
              })
            );
            // update homepage cache pessimistically end
            // update homepage cache pessimistically start
            dispatch(
              apiSlice.util.updateQueryData(
                "getTask",
                task.data.id.toString(),
                (draft) => {
                  Object.assign(draft, task.data);
                }
              )
            );
            // update homepage cache pessimistically end
          }
        } catch (error) {
          console.log(error);
        }
      },
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // optimistic cache update start
        const delDispatch = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            return draft?.filter((task) => Number(task.id) !== Number(arg));
          })
        );
        // optimistic cache update start
        try {
          await queryFulfilled;
        } catch (error) {
          delDispatch.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskQuery,
  useAddTaskMutation,
  useEditTaskMutation,
  useDeleteTaskMutation,
} = tasksApi;
